import { useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { sendAssetCartRequest } from '@api/assetCartRequest';

import { ISendAssetCartRequestDTO } from '@interfaces/rent/dto/assetCartDTO';

import { ESnackbarTypes } from '@enums/common';

import {
	ASSET_CART_REQUEST,
	ASSET_CART_REQUEST_AVAILABLE,
	ASSET_CART_REQUEST_COUNT,
	ASSET_CART_REQUEST_DROPDOWN,
	ASSET_CART_REQUEST_UNAVAILABLE,
} from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export const useMutateSendAssetCartRequest = () => {
	const dispatch = useAppDispatch();
	const queryClient = useQueryClient();

	const {
		mutate: handleSendAssetCartRequest,
		isLoading: isLoadingSendAssetCartRequest,
	} = useMutation<ISendAssetCartRequestDTO>({
		mutationKey: [ASSET_CART_REQUEST],
		mutationFn: sendAssetCartRequest,
		onSuccess: (_, variables) => {
			dispatch(setSnackbar({
				message: variables.isSingleRequest ? responseMessages.createRequest : responseMessages.createRequests,
				type: ESnackbarTypes.success,
			}));

			return [
				queryClient.invalidateQueries([ASSET_CART_REQUEST]),
				queryClient.invalidateQueries([ASSET_CART_REQUEST_COUNT]),
				queryClient.invalidateQueries([ASSET_CART_REQUEST_DROPDOWN]),
				queryClient.invalidateQueries([ASSET_CART_REQUEST_AVAILABLE]),
				queryClient.invalidateQueries([ASSET_CART_REQUEST_UNAVAILABLE]),
			];
		},
	});

	return {
		handleSendAssetCartRequest,
		isLoadingSendAssetCartRequest,
	};
};
